import { Grid } from "@mui/material";
import MxDisclaimer from "@rf-l1/disclaimers/MxDisclaimer";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";
import { IMxCatchmentHeader } from "./model/catchment.interface";

/**
 * Header del formulario de catchment con título y disclaimer informativo
 * Proporciona contexto visual sobre qué información se solicita
 */
export const MxCatchmentHeader = ({
  label = "Etapas y unidades",
  disclaimerMessage = "Indique el número de unidades del proyecto en cada etapa, según el master plan, no las unidades captadas",
  disclaimerVariant = "info"
}: IMxCatchmentHeader) => {
  return (
    <Grid container alignItems="center" gap={2}>
      <Grid item xs="auto">
        <MxFormSubTitle label={label} />
      </Grid>
      <Grid item xs="auto">
        <MxDisclaimer variant={disclaimerVariant} message={disclaimerMessage} />
      </Grid>
    </Grid>
  );
};

export default MxCatchmentHeader;
